import React, {PropsWithChildren} from 'react';


export default function LittleDetails({ children, className }: PropsWithChildren<{ className: string }>) {
    return (
        <p className={`text-sm gray-600 ${className}`}>
            {children}
        </p>
    );
}
